var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSummer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_46",
    transform: "translate(1 1)",
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_140",
    d: "M116.789,109.5a7.286,7.286,0,1,1-7.286-7.286A7.286,7.286,0,0,1,116.789,109.5Z",
    transform: "translate(-90.502 -90.501)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_5",
    y2: 6,
    transform: "translate(19 31)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_6",
    y2: 6,
    transform: "translate(19 1)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_7",
    x1: 3.976,
    y2: 3.976,
    transform: "translate(6.514 27.51)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_8",
    x1: 3.976,
    y2: 3.976,
    transform: "translate(27.51 6.514)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_9",
    x1: 6,
    transform: "translate(1 19)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_10",
    x1: 6,
    transform: "translate(31 19)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_11",
    x1: 3.976,
    y1: 3.976,
    transform: "translate(6.514 6.514)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_12",
    x1: 3.976,
    y1: 3.976,
    transform: "translate(27.51 27.51)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSummer);
export default __webpack_public_path__ + "static/media/icon-summer.5d962ce3f0f13ab4100da377b880a3d3.svg";
export { ForwardRef as ReactComponent };